import { IApplicationState } from '../../../../../types/types';
import { getAuthUserMetaMyWork } from '../../../../../store/model/selectors/getAuthUserMetaMyWork';

export const getHideMyWorkEmptyGroups = (
    state: IApplicationState
): boolean => {
    return getAuthUserMetaMyWork(state).isHideEmptyGroups;
};
